import {Helpers} from "@tpd-web-common-libs/nodejs-library";

export const OPTIONS = [
  {
    id: "condividiFacebook",
    iconClass: "icon-Facebook",
    action: (config: any, page: string) =>
      window.open(
          `https://www.facebook.com/sharer.php?u=https://www.${Helpers.BrandNameHelper.urlName()}.it${page}`
      ),
  },
  // {
  //   id: "condividiTwitter",
  //   iconClass: "icon-Twitter",
  //   action: (config: any, page?: string) =>
  //     window.open(
    //       `https://twitter.com/intent/tweet?url=https://www.${Helpers.BrandNameHelper.urlName()}.it${page}`
  //     ),
  // },
  {
    id: "condividiMailProdotto",
    iconClass: "icon-Mail",
    action: (config: any, page?: string) =>
        window.open(`mailto:?subject=''&body=https://www.${Helpers.BrandNameHelper.urlName()}.it${page}`),
  },
  {
    id: "condividiWAProdotto",
    iconClass: "icon-Wapp",
    action: (config: any, page?: string) =>
      window.open(
          ` https://api.whatsapp.com/send?text=https://www.${Helpers.BrandNameHelper.urlName()}.it${page}`
      ),
  },
];
